import { DateTime } from 'luxon';
import { SuccessCompassDataService } from './../../Services/success-campass.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Milestone, UserTaskNotificationVO } from 'app/models/psp-notification';
import { AppSettings } from 'app/app-settings';
import { HttpClientService } from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';


@Component({
  selector: 'app-activity-psp-info',
  templateUrl: './activity-psp-info.component.html',
  styleUrls: ['./activity-psp-info.component.css']
})

export class ActivityPspInfoComponent implements OnChanges{
  @Input() data: UserTaskNotificationVO = null;
  @Input() executionTrackerSync = false;
  @Input() journeyCourseId;
  @Output() syncEvent = new EventEmitter<string>();
  milestone: Milestone = null;
  completedMilestone: Milestone = null;
  timeZone: string = '';
  dataModified: boolean = false;
  canSyncPlanPsp = true;

  constructor(
    private SuccessCompassDataService: SuccessCompassDataService,
    private httpClientService: HttpClientService
  ){}

  ngOnChanges(changes: SimpleChanges): void {
    this.modifyData();
  }
  modifyData() {
    this.dataModified = false
    this.completedMilestone = null;
    this.milestone = null;
    this.timeZone = (this.data.userTimezoneVO && this.data.userTimezoneVO.timezone)?this.data.userTimezoneVO.timezone:DateTime.now().zoneName;
    if(this.data.notificationType == 'COMPLETED' || this.data.notificationType == 'COMPLETED_AUTO'){
      this.completedMilestone = this.data.completionMilestone;
      this.milestone = this.data.currentMilestone;
      this.completedMilestone.taskVO.taskStartDate = this.completedMilestone.taskVO.taskStartDate==null?null:this.SuccessCompassDataService.dateObjectFromMillis(this.completedMilestone.taskVO.taskStartDate,this.timeZone);
      this.completedMilestone.taskVO.taskEndDate = this.completedMilestone.taskVO.taskEndDate==null?null:this.SuccessCompassDataService.dateObjectFromMillis(this.completedMilestone.taskVO.taskEndDate,this.timeZone);
    }else{
      this.milestone = this.data.currentMilestone;
    }
    this.milestone.taskVO.taskStartDate = this.milestone.taskVO.taskStartDate==null?null:this.SuccessCompassDataService.dateObjectFromMillis(this.milestone.taskVO.taskStartDate,this.timeZone);
    this.milestone.taskVO.taskEndDate = this.milestone.taskVO.taskEndDate==null?null:this.SuccessCompassDataService.dateObjectFromMillis(this.milestone.taskVO.taskEndDate,this.timeZone);
    this.dataModified = true;
  }

  goToStudyPlan(){
    window.open(AppSettings.gfePSPUrl, '_blank');
  }

  syncPlanPsp(){
    if(this.canSyncPlanPsp){
      this.canSyncPlanPsp = false;
      let headers = new HttpHeaders();
      this.httpClientService
      .get(AppSettings.restApiUrl + "/api/update-stage-progress/journey/"+this.journeyCourseId, headers)
      .subscribe((data) => {
        this.canSyncPlanPsp = true;
        this.syncEvent.emit('Done');
      });
    }
  }
}
